export default __webpack_public_path__ + "static/media/rnr-sports-table-20.517912c2.webp";